<template>
  <div class="sale">
    <div class="mainWidth">
      <div class="main_box">
        <mu-row gutter class="main_tags">
          <mu-row gutter  class="tags_img_box">
            <mu-col width="100" tablet="30" desktop="30">
              <div class="tags_img">
                <img :src="$t('service.sale.foundImg')">
              </div>
            </mu-col>
            <mu-col class="tags_detail_box" width="100" tablet="70" desktop="70">
              <div class="tags_title_box">
                <div class="tags_intro_title">{{$t('service.sale.title')}}</div>
                <div class="tags_intro_subtitile">{{$t('service.sale.subtitle')}}</div>
              </div>

              <div class="tags_detail">
                <span>{{$t('service.sale.intro[0]')}}</span>
              </div>
            </mu-col>
          </mu-row>

        </mu-row>
        <mu-row gutter class="merit_list">
          <mu-col width="100" tablet="50" desktop="25" class=""  v-for="item in $t('service.sale.tags')" :key="item.title">
            <div class="item_box">
              <div class="title">{{item.title}}</div>
              <div class="subtitle">{{item.subtitle}}</div>
            </div>

          </mu-col>
        </mu-row>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    name: 'erange',
    data () {
      return {
        activeTab:'0',
      }
    },
    created(){

    },
    methods:{
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .sale{
    overflow:hidden;
    background-color:#E6E6E6;
    padding-bottom:60px;
    .main_box{
      background:#fff;
      margin-top:60px;
      width:96%;
      float:right;
      .main_tags{
        .tags_img_box{
          width:100%;
          height:auto;
          background: #FFFFFF;

          .tags_img{
            width:300px;
            height:300px;
            position:relative;

            >img{
              height:inherit;
              width:inherit;
              position:absolute;
              top:-40px;
              left:-40px;
            }
          }
          .tags_detail_box{
            .tags_title_box{
              margin-right:34px;
              height:134px;
              border-bottom:3px solid #6FA0FF;
              display:inline-block;
              .tags_intro_title{
                height:40px;
                line-height:40px;
                margin-top:40px;
                font-family: PingFangSC-Medium;
                font-size: 24px;
                color: #3B3B3B;
                letter-spacing: 0;
                display:inline-block;
                text-align:left;
                vertical-align:middle;
                width:auto;

              }
              .tags_intro_subtitile{
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #9196AC;
                letter-spacing: 0;
                width:auto;
              }
            }
            .tags_detail{
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color:#9196AC;
              letter-spacing:0;
              line-height: 27px;
              margin-right:34px;
              padding:40px 180px 0px 0px;
              border-top:3px solid #E8E8E8;
              margin-top:-3px;
            }
            .tags{
              span{
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #FF6363;
                letter-spacing: 0;
                line-height: 22px;
                padding:0px 8px;
                font-weight:600;
              }
              .tags_icon{
                width:16px;
                height:13px;
                display:inline-block;
                margin-right:8px;
                img{
                  width:inherit;
                  height:inherit;
                }
              }
            }


          }

        }

      }
      .merit_list{
        width:100%;
        height:auto;
        overflow:hidden;
        padding:40px;
        padding-left:200px;
        .item_box{
          float:right;
          .title{
            font-family: PingFangSC-Medium;
            font-size: 30px;
            color: #333333;
            letter-spacing: 0;
            line-height: 33px;

          }
          .subtitle{
            margin-top:16px;
            display:inline-block;
            font:16px/28px;
            color:#fff;
            border-radius:14px;
            padding:0px 18px;
            background:linear-gradient(left,#008AFF,#10DCFF);
          }
        }

      }

      }


  }

</style>




// WEBPACK FOOTER //
// src/page/childrens/aftersaleservice.vue